import { render } from "./InputMsg.vue?vue&type=template&id=bd2c7ec0"
import script from "./InputMsg.vue?vue&type=script&lang=js"
export * from "./InputMsg.vue?vue&type=script&lang=js"

import exportComponent from "E:\\moneyman\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__